import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";
import { FC, Fragment } from "react";

import { CloseIcon } from "../SvgIcon";

interface IProps {
  children: React.ReactNode;
  isOpen: boolean;
  closeModal: () => void;
  title?: string;
  width?: string;
  bgColor?: string;
  hideCloseBtn?: boolean;
}
export const Modal: FC<IProps> = ({
  children,
  isOpen,
  closeModal,
  title,
  width = "w-full max-w-lg p-6",
  bgColor = "bg-white",
  hideCloseBtn = false
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[999]" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={classNames(
                  `${width} transform rounded-2xl ${bgColor} text-left align-middle shadow-xl transition-all`
                )}
              >
                <div
                  className={classNames("flex justify-between items-center", {
                    "border-b border-gray-300 pb-5 mb-5": title
                  })}
                >
                  {title ? (
                    <Dialog.Title as="h3" className="text-lg md:text-xl font-bold leading-6 text-gray-900">
                      {title}
                    </Dialog.Title>
                  ) : null}

                  {hideCloseBtn ? null : (
                    <button
                      type="button"
                      onClick={closeModal}
                      className="w-8 h-8 rounded-full flex items-center justify-center"
                    >
                      <CloseIcon
                        strokeColor="text-primary"
                        classes="w-full h-full transition-all hover:text-gray-700"
                      />
                    </button>
                  )}
                </div>

                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
